export class CompanyAddressModel {
Title: string;
City: string;
State: string;
PhoneNumber: string;
ZipCode: string;
Country: string;
Email: string;
Name: string;
Id: number;
Street: string;
}

export class CompanyAddressList {
city: string;
country: string;
createdOn: string;
email: string;
id: number;
modifiedOn: string;
name: string;
phoneNumber: string;
state: string;
title: string;
zipCode: string;
}

export class UpdateCompanyAddressModel {
Id: number;                                                                                                    
title: string;
city: string;
state: string;
phoneNumber: string;
zipCode: string;
country: string;
email: string;
name: string;
street: string;
}

export class UpdateCompanyAddressVm{
Id: number;                                                                                                    
Title: string;
City: string;
State: string;
PhoneNumber: string;
ZipCode: string;
Country: string;
Email: string;
Name: string;                                                                                                   
}

export class DeleteCompanyAddressModel{
Id: number;                                                                                                   
}